// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"wl_a bht_b bht_ux"};